/* eslint-disable @typescript-eslint/no-explicit-any */
'use client'

import { AnimatePresence, motion } from 'motion/react'
import ArrowLeft from 'public/assets/arrow-left.svg'
import ArrowRight from 'public/assets/arrow-right.svg'
import { useState } from 'react'
import styles from './CarouselClient.module.scss'

type ImageProps = {
  src: string
  alt: string
  props: any
}

type CarouselClientProps = {
  images: ImageProps[]
}

const CarouselClient = ({ images }: CarouselClientProps) => {
  const [[currentIndex, direction], setCurrentIndex] = useState([0, 0])
  const currentImage = images[currentIndex]

  const paginate = (newDirection: number) => {
    setCurrentIndex([currentIndex + newDirection, newDirection])
  }

  function enabledLeft() {
    return currentIndex > 0
  }

  function enabledRight() {
    return currentIndex < images.length - 1
  }

  const variants = {
    enter: (direction: number) => {
      return {
        x: direction > 0 ? '100%' : '-100%',
        opacity: 0,
      }
    },
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1,
    },
    exit: (direction: number) => {
      return {
        zIndex: 0,
        x: direction < 0 ? '100%' : '-100%',
        opacity: 0,
      }
    },
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.controls}>
          <span className={styles.counter}>
            {currentIndex + 1}/{images.length}
          </span>
          <div className={styles.arrows}>
            <ArrowLeft className={styles.arrow + ' ' + (enabledLeft() ? styles.enabled : '')} onClick={() => enabledLeft() && paginate(-1)} />
            <ArrowRight className={styles.arrow + ' ' + (enabledRight() ? styles.enabled : '')} onClick={() => enabledRight() && paginate(1)} />
          </div>
        </div>
        <em className={styles.caption}>{currentImage.alt}</em>
      </div>
      <motion.div layout className={styles['image-container']}>
        <AnimatePresence initial={false} custom={direction}>
          <motion.img
            key={currentImage.alt}
            src={currentImage.src}
            alt={currentImage.alt}
            className={styles.image}
            custom={direction}
            variants={variants}
            initial='enter'
            animate='center'
            exit='exit'
            transition={{
              duration: 0.5,
              ease: 'easeOut',
            }}
          />
        </AnimatePresence>
      </motion.div>
    </div>
  )
}

export default CarouselClient
